import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CoreService } from '@services/common/core.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  isLoading$ = new BehaviorSubject<boolean | null>(null);

  constructor(public coreService: CoreService) {
    // this.isLoading$ = this.coreService.getLoader();
  }
}
